export const SHOP_LOCATIONS_UNINITIALIZED_MODE = "uninitialized";
export const SHOP_LOCATIONS_DEFAULT_MODE = "default";
export const SHOP_LOCATIONS_NO_SHOPS_MODE = "no-shops";
export const SHOP_LOCATIONS_COUNTRY_MODE = "country";
export const SHOP_LOCATIONS_CITY_MODE = "city";

export type ShopLocationsUninitializedMode =
    typeof SHOP_LOCATIONS_UNINITIALIZED_MODE;
export type ShopLocationsDefaultMode = typeof SHOP_LOCATIONS_DEFAULT_MODE;
export type ShopLocationsNoShopsMode = typeof SHOP_LOCATIONS_NO_SHOPS_MODE;
export type ShopLocationsCountryMode = typeof SHOP_LOCATIONS_COUNTRY_MODE;
export type ShopLocationsCityMode = typeof SHOP_LOCATIONS_CITY_MODE;

export interface ContinentEntry {
    name: string;
    countries: CountryEntry[];
    closed: boolean;
}

export interface CountryEntry {
    translatedCountry: string;
    countryCode: string;
    slugifiedCountry: string;
    path: string;
    continentName: string;
}

export interface CityEntry {
    translatedCity: string;
    slugifiedCity: string;
}

export interface UninitializedState {
    pageMode: ShopLocationsUninitializedMode;
    continents: ContinentEntry[];
    countries: CountryEntry[];
    cities: CityEntry[];
}

export interface DefaultState {
    pageMode: ShopLocationsDefaultMode;
    continents: ContinentEntry[];
    countries: CountryEntry[];
    cities: CityEntry[];
    currentCountry: CountryEntry;
}

export interface NoShopsState {
    pageMode: ShopLocationsNoShopsMode;
    continents: ContinentEntry[];
    countries: CountryEntry[];
    cities: CityEntry[];
}

export interface CountryState {
    pageMode: ShopLocationsCountryMode;
    continents: ContinentEntry[];
    countries: CountryEntry[];
    cities: CityEntry[];
    currentCountry: CountryEntry;
}

export interface CityState {
    pageMode: ShopLocationsCityMode;
    continents: ContinentEntry[];
    countries: CountryEntry[];
    cities: CityEntry[];
    currentCity: CityEntry;
    currentCountry: CountryEntry;
}

export type ShopLocationsPageMode = ShopLocationsState["pageMode"];

export type CurrentShopLocation =
    | Pick<CountryState, "currentCountry" | "pageMode">
    | Pick<CityState, "currentCountry" | "currentCity" | "pageMode">
    | Pick<DefaultState, "currentCountry" | "pageMode">
    | Pick<NoShopsState, "pageMode">;

export type ShopLocationsState =
    | UninitializedState
    | DefaultState
    | NoShopsState
    | CountryState
    | CityState;

export const initialShopLocationsState: ShopLocationsState = {
    pageMode: SHOP_LOCATIONS_UNINITIALIZED_MODE,
    continents: [],
    countries: [],
    cities: [],
};
